import Vue from "vue";
import Router from "vue-router";
import store from "../store";

import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "bulma-pageloader";

import tokenLogin from "@/components/security/tokenLogin";
import Home from "@/components/page/Home";
import Portail from "@/components/page/Portail";
import Admin from "@/components/page/Admin";
import AdminLinks from "@/components/page/AdminLinks";
import Attendees from "@/components/page/Attendees";
import AttendeesMod from "@/components/page/AttendeesMod";
import VueQriously from "vue-qriously";
import VueSocketio from "vue-socket.io";

// Import de mon hack perso css bulma
require("@/assets/css/perso.css");

Vue.use(Router);
Vue.use(Buefy, { defaultIconPack: "fa" });
Vue.use(VueQriously);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/:shortcut.htm",
      name: "portail",
      component: Portail
    },
    {
      path: "/moderateur/:shortcut_moderateur.htm",
      name: "portailAdmin",
      component: Portail
    },
    {
      path: "/moderateur/attendees/:shortcut_moderateur.htm",
      name: "AttendeesMod",
      component: AttendeesMod,
      beforeEnter: (to, from, next) => {
        Vue.use(VueSocketio, process.env.NODE_SERVEUR);
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
      }
    },
    {
      path: "/attendees/:shortcut.htm",
      name: "AttendeesPublic",
      component: AttendeesMod,
      beforeEnter: (to, from, next) => {
        Vue.use(VueSocketio, process.env.NODE_SERVEUR);
        document.getElementsByTagName("html")[0].style.overflowX = "hidden";
        next();
      }
    },
    {
      path: "/tokenLogin",
      name: "tokenLogin",
      component: tokenLogin
    },
    {
      path: "/admin",
      name: "Admin",
      component: Admin,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          document.getElementsByTagName("html")[0].style.overflowX = "auto";
          next();
        } else {
          window.location = process.env.URL_SSO_FRONT;
        }
      }
    },
    {
      path: "/admin/links",
      name: "AdminLinks",
      component: AdminLinks,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          document.getElementsByTagName("html")[0].style.overflowX = "hidden";
          next();
        } else {
          window.location = process.env.URL_SSO_FRONT;
        }
      }
    },
    {
      path: "/admin/attendees",
      name: "AdminAttendees",
      component: Attendees,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          Vue.use(VueSocketio, process.env.NODE_SERVEUR);
          document.getElementsByTagName("html")[0].style.overflowX = "hidden";
          next();
        } else {
          window.location = process.env.URL_SSO_FRONT;
        }
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js